import purchasedTag from './purchasedTag';
import setUserData from './userData';

const dataLayer = data => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

export { dataLayer as default, purchasedTag, setUserData };
